/**
 * Search Button Module
 *
 * 検索ボタンの動作
 */
export function searchButton() {
	document.body.addEventListener('click', (e) => {
		// 検索ボタンがクリックされた場合
		const searchButton = e.target.closest('[data-search-button]');
		// クリックされた要素が検索ボタンでない場合は何もしない
		if (!searchButton) return;

		// タグとエリアの値が入っているspan要素を取得
		const tagSpan = document.querySelector('[data-search-target="tag"]');
		const areaSpan = document.querySelector('[data-search-target="area"]');

		// タグとエリアの値を取得
		const tag = tagSpan?.dataset.searchId || "";
		const area = areaSpan?.dataset.searchId || "";

		// 現在のサイトURLを基準にして、検索結果のURLを生成
		const baseUrl = `${window.location.origin}/clinic-search/`;

		let url = "";

		// タグとエリアの値に応じてURLを生成
		if (tag && area) {
			url = `${baseUrl}${area}/${tag}/`;
		} else if (tag && !area) {
			url = `${baseUrl}0/${tag}/`;
		} else if (!tag && area) {
			url = `${baseUrl}${area}/`;
		} else {
			url = `${baseUrl}0/`;
		}

		// 生成したURLに遷移
		window.location.href = url;
	});
}